// removed by extract-text-webpack-plugin
module.exports = {"AnimHeart":"AnimHeart__AnimHeart__-hash-base-64-5-","HeartAdding":"AnimHeart__HeartAdding__-hash-base-64-5-","move":"AnimHeart__move__-hash-base-64-5-","HeartRemoving":"AnimHeart__HeartRemoving__-hash-base-64-5-","NotDisplay":"AnimHeart__NotDisplay__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/AnimHeart/AnimHeart.scss
// module id = 194
// module chunks = 0